<div class="clearfix"></div>
<form action="">
  <div class="form-row row">
    <div class="form-group mt-3 ms-2">
      <label for="manageProductCollies">
        <input type="checkbox" id="manageProductCollies" name="manageProductCollies" #manageProductCollies="ngModel"
               [(ngModel)]="hasCollies" (ngModelChange)="showProductColliesForm($event)">
        {{'doctrine.product.collies.check_mark'| translate}}
      </label>
    </div>
  </div>
</form>
<form [formGroup]="colliesForm" *ngIf="hasCollies" #productColliesForm>
  <div formArrayName="collies">
    <div *ngFor="let collieItem of colliesFormArray.controls; let i = index" [formGroupName]="i">
        <div class="form-row row">
          <div class="form-group col-md-6">
            <label [for]="'name' + i" class="float-label">{{'doctrine.product.collies.label'|translate}} {{i + 1}}
              <span class="star">*</span>
            </label>
            <input class="form-control" formControlName="name" [id]="'name' + i" required>
            <div class="messages text-danger"
              *ngIf="collieItem.get('name').invalid && (collieItem.get('name').dirty || collieItem.get('name').touched)">
              <div *ngIf="collieItem.get('name').errors.required">
                {{'errors.required'|translate}}
              </div>
            </div>
          </div>
          <div class="form-group col-md-2 mt-4">
            <a *ngIf="i > 1" (click)="deleteCollie(i)"
               class="btn btn-lg btn-primary btn-icon ripple light ms-1">
              <i class="fa fa-remove"></i>
            </a>
          </div>
        </div>
    </div>
  </div>
  <button (click)="addCollies()" type="button" class="btn btn-simple ripple me-2 btn-primary light">
    <i class="feather icon-plus ng-star-inserted"></i>
    <label class="mb-0 ms-1">{{'global.add' | translate}}</label>
  </button>
</form>


